import gql from 'graphql-tag';

export default gql`
  mutation archiveAudience($audienceId: UUID!, $channelId: UUID!) {
    archiveAudience(audienceId: $audienceId, channelId: $channelId)
  }
`;
